import { safeParseFloat } from './parse-float'

export function formatPrice(
  price: string | number | undefined | null,
  currency?: string | null,
) {
  if (!price) return `0  ${currency || '$'}`

  const value = safeParseFloat(price)

  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value)

  return `${formattedNumber} ${currency || '$'}`
}
